import { useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import Orders from "@/pages/Orders";
import BuyerPoOrder from "@/pages/BuyerPoOrder";
import OrderConsolidation from "@/pages/OrderConsolidation";

// Orders module (desktop). Same shared backend / order logic.
// Buyer PO Upload folded in as a tab (preserves existing PO-upload functionality).
export default function OrdersModule() {
  const [tab, setTab] = useState("orders");
  return (
    <Tabs value={tab} onValueChange={setTab} className="space-y-4">
      <TabsList data-testid="orders-tabs" className="bg-stone-100">
        <TabsTrigger value="orders" data-testid="orders-tab-orders">Orders</TabsTrigger>
        <TabsTrigger value="po-upload" data-testid="orders-tab-po-upload">Buyer PO Upload</TabsTrigger>
        <TabsTrigger value="consolidation" data-testid="orders-tab-consolidation">Order Consolidation</TabsTrigger>
      </TabsList>
      <TabsContent value="orders"><Orders /></TabsContent>
      <TabsContent value="po-upload"><BuyerPoOrder /></TabsContent>
      <TabsContent value="consolidation"><OrderConsolidation /></TabsContent>
    </Tabs>
  );
}
